<template>
  <div v-if="showCampaignBox" v-cloak data-test-campaign-box class="campaign-box">
    <bg-image v-if="showBgImage" :images="vueModel.croppedImage">
      <campaign-box-splash-circle
        :title="vueModel.splashTitle"
        :text="vueModel.splashBody"
        :left-alignment="vueModel.splashAlignLeft"
      />
      <consumer-test-logo
        v-if="showConsumerTestLogo"
        :logo="vueModel.consumerTestImage.url"
        :left-alignment="vueModel.consumerTestAlignLeft"
      />
    </bg-image>
    <text-field
      v-if="showTextField"
      :title="vueModel.textFieldTitle"
      :text="vueModel.textFieldText"
      :bg-colour-class="vueModel.textFieldBgColour"
    >
      <campaign-box-splash-circle
        :title="vueModel.splashTitle"
        :text="vueModel.splashBody"
        :left-alignment="vueModel.splashAlignLeft"
      />
    </text-field>
  </div>
</template>

<script lang="ts">
import axios from 'axios';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import Utility from '@/common/UtilityFunctions.js';
import VueModel from './_interfaces/vueModel';
import TextField from './components/TextField.vue';
import ConsumerTestLogo from './components/ConsumerTestLogo.vue';
import CampaignBoxSplashCircle from './components/CampaignBoxSplashCircle.vue';
import BgImage from './components/BgImage.vue';
import { ProposalBasketStoreState } from '@/store/modules/interfaces/ProposalBasketStoreState';

export default defineComponent({
  name: 'CampaignBox',
  components: {
    BgImage,
    ConsumerTestLogo,
    CampaignBoxSplashCircle,
    TextField
  },
  props: {
    datasource: {
      type: String,
      default() {
        return '';
      }
    },
    campaignBoxType: {
      type: String,
      default() {
        return '0';
      }
    }
  },
  data() {
    return {
      vueModel: {
        croppedImage: null,
        textFieldTitle: '',
        textFieldText: '',
        textFieldBgColour: '',
        splashElementBgColour: '',
        splashTitle: '',
        splashBody: '',
        splashAlignLeft: false,
        consumerTestImage: null,
        consumerTestAlignLeft: true
      } as VueModel,
      loading: true
    };
  },
  computed: {
    ...mapState('proposalBasket', {
      updateComponentVsBasket: (state) =>
        (state as ProposalBasketStoreState).updateComponentVsBasket,
      proposalsInBasket: (state) => (state as ProposalBasketStoreState).proposalsInBasket,
      digitalProposalsInBasket: (state) =>
        (state as ProposalBasketStoreState).digitalProposalsInBasket,
      manualProposalsInBasket: (state) =>
        (state as ProposalBasketStoreState).manualProposalsInBasket,
      areAllProposalsManual: (state) => (state as ProposalBasketStoreState).areAllProposalsManual
    }),
    showCampaignBox(): boolean {
      if (this.updateComponentVsBasket && this.proposalsInBasket === 0) {
        return false;
      }

      if (this.updateComponentVsBasket && this.proposalsInBasket > 0) {
        return (
          this.vueModel !== null &&
          (this.campaignBoxType === '0' ||
            (this.campaignBoxType === '1' && this.digitalProposalsInBasket > 0) ||
            (this.campaignBoxType === '2' && this.areAllProposalsManual))
        );
      }

      return this.vueModel !== null;
    },
    showBgImage(): boolean {
      return this.vueModel !== null && this.vueModel.croppedImage !== null;
    },
    showTextField(): boolean {
      return (
        this.vueModel !== null &&
        this.vueModel.croppedImage === null &&
        (this.vueModel.textFieldTitle !== '' || this.vueModel.textFieldText !== '')
      );
    },
    showConsumerTestLogo(): boolean {
      return this.vueModel.consumerTestImage !== null;
    }
  },
  mounted() {
    this.getContent();
  },
  methods: {
    getContent() {
      axios
        .get(Utility.constants().API.campaignbox + this.datasource)
        .then((response) => {
          this.vueModel = response.data;
        })
        .catch((error) => {
          Utility.logError(error, this);
        });
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
.campaign-box {
  margin-bottom: rem-calc(40);

  @media #{$large-up} {
    margin-bottom: rem-calc(20);
  }
}
</style>
